export { carouselVariables as carouselItemVariables } from './carouselVariables';
